import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BannerService, BannerDto } from './banner.service';
import { NotificationService } from '../../core/notification.service';

@Component({
  standalone: false,
  selector: 'app-banner-form',
  templateUrl: './banner-form.component.html',
  styleUrls: ['./banner-form.component.css']
})
export class BannerFormComponent implements OnInit {
  loading = false;
  saving = false;
  id: string | null = null;

  // Using documented field names
  title = '';
  description = '';
  imageUrl = '';
  linkUrl = '';
  isActive = true;

  constructor(private route: ActivatedRoute, private router: Router, private svc: BannerService, private notify: NotificationService) {}

  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get('id');
    if (this.id) {
      this.load();
    }
  }

  load(): void {
    if (!this.id) return;
    this.loading = true;
    this.svc.getById(this.id).subscribe({
      next: (b: BannerDto) => {
        // Map backend fields (handling both PascalCase and camelCase)
        this.title = b.title || b.nome || '';
        this.description = b.description || b.localizacao || '';
        this.imageUrl = b.imageUrl || '';
        this.linkUrl = b.linkUrl || b.linkDestino || '';
        this.isActive = b.isActive !== undefined ? b.isActive : (b.ativo !== undefined ? b.ativo : true);
        this.loading = false;
      },
      error: (err) => {
        console.error('[Banner] erro ao carregar', err);
        this.notify.showError('Erro ao carregar banner');
        this.loading = false;
      }
    });
  }

  save(): void {
    this.saving = true;
    const payload: Partial<BannerDto> = {
      title: this.title,
      description: this.description,
      imageUrl: this.imageUrl,
      linkUrl: this.linkUrl || undefined,
      isActive: this.isActive
    } as any;

    const req = this.id ? this.svc.update(this.id, payload) : this.svc.create(payload);
    req.subscribe({
      next: () => {
        this.notify.showSuccess('Banner salvo com sucesso');
        this.router.navigate(['/admin/config/banners']);
      },
      error: (err) => {
        console.error('[Banner] erro ao salvar', err);
        this.notify.showError('Erro ao salvar banner');
        this.saving = false;
      }
    });
  }

  cancel(): void {
    this.router.navigate(['/admin/config/banners']);
  }
}
